import { connect } from "react-redux";
import {
  getLanDongLaiChoVay,
  postTatToanChoVay,
  postTatToanChoDuyetChoVay,
  getTatToanChoVay,
  postThayDoiLaiSuatChoVay,
} from "actions/QuanLyChoVay";
import ThayDoiLaiSuat from "components/CommonComponent/ThayDoiLaiSuat";

const mapStateToProps = (state) => ({
  camdo: state.camdo,
  quanlychovay: state.quanlychovay,
  quanlythuchi: state.quanlythuchi,
  user: state.user,
  cauhinh: state.cauhinh,
  themmoicamdo: state.themmoicamdo,
  phanquyen: state.phanquyen,
  loaitaisan: state.loaitaisan,
  inthuchi: state.inthuchi,
});

const mapDispatchToProps = (dispatch) => ({
  getLanDongLaiChoVay: (dataSearch) =>
    dispatch(getLanDongLaiChoVay(dataSearch)),
  postTatToanChoVay: (dataPost) => dispatch(postTatToanChoVay(dataPost)),
  postThayDoiLaiSuatChoVay: (dataPost) => dispatch(postThayDoiLaiSuatChoVay(dataPost)),
  postTatToanChoDuyetChoVay: (dataPost) => dispatch(postTatToanChoDuyetChoVay(dataPost)),
  getTatToanChoVay: (dataPost) => dispatch(getTatToanChoVay(dataPost)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ThayDoiLaiSuat);
